import NavbarComponent from '@/components/Navbar';
import Busy from '@/components/Busy';
import Notification from '@/components/Notification';

export const basicLayout = {
  busy: Busy,
  notification: Notification,
};

export const loginLayout = {
  ...basicLayout,
};

export const dashLayout = {
  navbar: NavbarComponent,
  ...basicLayout,
};

export default {
  basicLayout,
  loginLayout,
  dashLayout,
};



// WEBPACK FOOTER //
// ./src/router/layout.js